import styled, { css } from 'styled-components';
import HvSvg from 'src/components/HvSvg';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

// Category Group Styles
export const CategoryContainer = styled.div`
  width: 100%;
  padding: 12px 20px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.sidebarGray};

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    /* if notch, add half a notch in left padding */
    padding-left: calc(20px + env(safe-area-inset-left) / 2);
  }
`;

export const MaterialButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 260px;
  @media ${DEVICE.MOBILE} {
    width: 100%;
  }
`;

export const CategoryName = styled.div`
  display: inline-block;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.trueBlack};
  ${({ theme }) => css`
    ${theme.mixins.font('bold', 16)}
  `}
`;

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 4px 0 8px;
  height: 17px;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  cursor: pointer;
  &:hover div {
    color: ${({ theme }) => theme.colors.defaultActionBlue};
    svg path {
      fill: ${({ theme }) => theme.colors.defaultActionBlue};
    }
  }
`;

export const MaterialCount = styled.div`
  margin-right: -6px;
  color: ${({ theme }) => theme.colors.mediumGrayFive};
  ${({ theme }) => css`
    ${theme.mixins.font('light', 16)}
  `}

  .hv-svg {
    display: inline-block;
  }
`;

// Material Button Styles
export const MaterialButtonThumbnail = styled.div`
  position: relative;
  width: 125px;
  height: 60px;
  margin-bottom: 4px;
  background-size: cover;
  background-image: url(${({ url }) => url});

  @media ${DEVICE.MOBILE} {
    max-width: 190px;
    width: auto;
  }

  ${({ color }) => {
    if (color) {
      return `
        background-color: ${color};
        background-blend-mode: multiply;
      `;
    }
  }}
`;

export const MaterialButtonEditIcon = styled(HvSvg)`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};

  svg path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const MaterialButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 125px;
  height: 77px;
  margin-bottom: 8px;
  &:nth-child(odd) {
    margin-right: 10px;
  }

  @media ${DEVICE.MOBILE} {
    width: 50%;
    padding: 0px 5px;
    &:nth-child(odd) {
      margin-right: 0px;
    }
  }

  &:hover ${MaterialButtonThumbnail} {
    cursor: pointer;
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.defaultActionBlue};
  }
  &:hover ${MaterialButtonEditIcon} {
    display: block;
  }
`;

export const MaterialButtonName = styled.div`
  color: ${({ theme }) => theme.colors.trueBlack};
  ${({ theme }) => css`
    ${theme.mixins.font('light', 11)}
  `}
`;
